module.exports = __webpack_public_path__ + "static/media/Google__G__Logo.b316e137.png";